{
  "overridesEnabledBadgeLabel": "Sobrepor em"
}
